import fetchAPI from '../../common/fetchAPI';
import { TimeOffRequestStateClass } from './interfaces/timeoffrequestStateClass';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { setTimesheetStatus } from '../../common/timesheetFunction';
import moment from 'moment';

const initialState: TimeOffRequestStateClass = {
    isLoading: true,
    status: 'idle',
    timeoffrequestList: [],
    timeoffrequeststatusList: [],
    accountemployeetimeoffrequestid: '',
    //pagination
    startRec: 0,
    search: '',
    pageNo: 1,
    pageSize: 10,
    totalItems: 0,
    recordsFiltered: 0,
    isSearch: false,
    isShowGrid: false,
    currentPage: 1,
    start: 0,
    sortOrder: 'ASC',
    sortColumn: '5',
    //pagination
    isShowTimeOffInDays: false,
    isShowProjectForTimeOff: false,
    isLockSubmittedRecords: false,
    isLockApprovedRecords: false,
    isHideTimeOffHoursInformation: false,
    culture: '',
    startDateTimeOff: (() => {
        const newDate = new Date();
        newDate.setMonth(newDate.getMonth() - 1); 
        return newDate.toISOString();
    })(),
    endDateTimeOff: (() => {
        const newDate = new Date();
        newDate.setMonth(newDate.getMonth() + 1);
        return newDate.toISOString();
    })(),
    TimeOffTypeId:'00000000-0000-0000-0000-000000000000',
    TimeOffStatus:'All',
    isReloadStatus: false,
    selectedStatus: '',
}

interface IThunkApi {
    state: {
        globalState: any;
        timeoffrequest: TimeOffRequestStateClass;
    },
}

export const getTimeOffRequestList = createAsyncThunk
    <any, void, IThunkApi>
    (
        'TimeOffs/getTimeOffRequestList',
        async (arg, thunkApi) => {
            const { startRec, search, pageNo, pageSize, sortOrder, sortColumn,startDateTimeOff,endDateTimeOff,TimeOffTypeId,TimeOffStatus } = thunkApi.getState().timeoffrequest;
            const { dateInsertionFormat } = thunkApi.getState().globalState           
            const StartDate = moment(startDateTimeOff).format(dateInsertionFormat)
            const EndDate = moment(endDateTimeOff).format(dateInsertionFormat)
            let ApprovalStatus : any = TimeOffStatus === 'All' ? '' : TimeOffStatus
            let AccountTimeOffTypeId : any = TimeOffTypeId === '00000000-0000-0000-0000-000000000000' ? '' : TimeOffTypeId           
            const response = await fetchAPI(`api/V2/TimeOffs/GetAccountTimeOffRequestForReactFilters?page=${pageNo}&pageSize=${pageSize}&start=${startRec}&Order=${sortColumn}&OrderDir=${sortOrder}&search=${search}&StartDate=${StartDate}&EndDate=${EndDate}&AccountTimeOffTypeId=${AccountTimeOffTypeId}&ApprovalStatus=${ApprovalStatus}`, "GET", "", true);
            //const response = await fetchAPI(`api/V2/TimeOffs/GetAccountEmployeeTimeOffRequest/${startRec}/${pageSize}/${pageNo}/${sortOrder}/${sortColumn}/${search}`, `Get`, '', true);
            const json = await response.json();
            return json;
        }
    )

export const getTimeOffRequestStatusList = createAsyncThunk
    <any, any, IThunkApi>
    (
        'TimeOffs/getTimeOffRequestStatusList',
        async (arg, thunkApi) => {
            const response = await fetchAPI(`api/V2/TimeOffs/GetTimeOffStatus/${arg}/`, `Get`, '', true);
            const json = await response.json();
            return json;
        }
    )

export const addAccountEmployeeTimeOffRequest = createAsyncThunk
    <any, any, IThunkApi>
    (
        'TimeOffs/addAccountEmployeeTimeOffRequest',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/TimeOffs/AddRecordTimeOffRequest/', 'POST', arg, true);
            const json = await response.json();
            let reduxObject = {
                "StartDate": moment(arg.StartDate).format('DD MMM yy'),
                "EndDate": moment(arg.EndDate).format('DD MMM yy'),
                "HoursOff": arg.HoursOff,
                "DayOff": arg.DayOff,
                "Description": arg.Description,
                "AccountTimeOffType": arg.AccountTimeOffType
            }
            return { res: json, reduxObject: reduxObject }
        }
    )

export const updateAccountEmployeeTimeOffRequest = createAsyncThunk
    <any, any, IThunkApi>
    (
        'TimeOffs/updateAccountEmployeeTimeOffRequest',
        async (arg, thunkApi) => {
            let reduxObject = {
                "StartDate": moment(arg.StartDate).format('DD MMM yy'),
                "EndDate": moment(arg.EndDate).format('DD MMM yy'),
                "HoursOff": arg.HoursOff,
                "DayOff": arg.DayOff,
                "Description": arg.Description,
                "AccountTimeOffType": arg.AccountTimeOffType
            }
            const response = await fetchAPI('api/V2/TimeOffs/' + arg.AccountEmployeeTimeOffRequestId, 'PUT', arg, true);
            const json = await response.json();
            return { res: json, reduxObject: arg, id: arg.AccountEmployeeTimeOffRequestId }
        }
    )

export const bulkSubmitAccountEmployeeTimeOffRequests = createAsyncThunk
    <any, any, IThunkApi>
    (
        'TimeOffs/bulkSubmitAccountEmployeeTimeOffRequests',
        async (ids, thunkApi) => {
            console.log('BulkSubmit :', ids)
            const response = await fetchAPI('api/V2/TimeOffs/BulkSubmit', 'POST', { AccountEmployeeTimeOffRequestIds: ids }, true);
            const json = await response.json();
            return { res: json, ids: ids }
        }
    )


export const deleteAccountEmployeeTimeOffRequest = createAsyncThunk
    <any, any, IThunkApi>
    (
        'TimeOffs/deleteAccountEmployeeTimeOffRequest',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/TimeOffs/' + arg, 'DELETE', '', true);
            const json = await response.json();
            return json;
        }
    )

export const timeoffrequestSlice = createSlice({
    name: 'timeoffrequest',
    initialState,
    reducers: {

        resetSelectedFiltersInState: (state) => {
            state.startDateTimeOff = (() => {
                const newDate = new Date();
                newDate.setMonth(newDate.getMonth() - 1);
                return newDate.toISOString();
            })();        
            state.endDateTimeOff = (() => {
                const newDate = new Date();
                newDate.setMonth(newDate.getMonth() + 1);
                return newDate.toISOString();
            })();
            state.startRec = 0;
            state.pageSize = 10;
            state.pageNo = 1;
            state.search = '';
            state.isSearch = false;
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.startRec = action.payload.startRec;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },

        updateSearchPagination: (state, action: PayloadAction<any>) => {
            state.isSearch = state.isSearch ? false : true;
            state.search = action.payload;
        },
        updateIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        updateAccountEmployeeTimeOffRequestId: (state, action: PayloadAction<any>) => {
            
            state.accountemployeetimeoffrequestid = action.payload;
        },
        updatePreferences: (state, action: PayloadAction<any>) => {
            state.isShowTimeOffInDays = action.payload.isShowTimeOffInDays;
            state.isShowProjectForTimeOff = action.payload.isShowProjectForTimeOff;
            state.isLockSubmittedRecords = action.payload.isLockSubmittedRecords;
            state.isLockApprovedRecords = action.payload.isLockApprovedRecords;
            state.isHideTimeOffHoursInformation = action.payload.isHideTimeOffHoursInformation;
            state.culture = action.payload.culture;
        },
        updateSorting: (state, action: PayloadAction<any>) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.startRec = action.payload.startRec;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
        },
        setDateRangeValue: (state, action) => {          
            const { startDate, endDate } = action.payload;
            
            state.startDateTimeOff = startDate;
            state.endDateTimeOff = endDate;
        },
        updateAccountTimeOffTypeId: (state, action: PayloadAction<any>) => {
            state.TimeOffTypeId = action.payload;
        },
        updateAccountTimeOffStatus: (state, action: PayloadAction<any>) => {
            state.TimeOffStatus = action.payload;
        },
        setPageSize: (state, action) => {
            state.pageSize = action.payload;
        },
        setSelectedTimeOffStatus: (state, action) => {
            state.selectedStatus = action.payload;
        }
       
    },
    extraReducers: (builder) => {
        builder
            .addCase(getTimeOffRequestList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getTimeOffRequestList.fulfilled, (state, action) => {
                let timeOffRequestList = JSON.parse(action.payload.data);
                timeOffRequestList.length > 0 && timeOffRequestList.map((item: any) => {
                    const currentApprovalStatus = item.ApprovalStatus;
                    delete item.ssnnoo;
                    delete item.AccountEmployeeId;
                    delete item.AccountId;
                    delete item.IsTimeOffRequestRequired;
                    delete item.ApprovalStatus;
                    delete item.Earned;
                    delete item.Consume;
                    delete item.Available;
                    delete item.CarryForward;
                    delete item.AccountProjectId;
                    item.TimeOffStatus = setTimesheetStatus(item.Approved, item.Rejected, (item.Approved == false && item.Rejected == false ? true : false)).text;
                    item.TimeOffStatusColor = setTimesheetStatus(item.Approved, item.Rejected, item.Approved == false && (item.Rejected == false ? true : false)).class
                    if (currentApprovalStatus === 'Not Submitted' || item.IsSaveDraft === true) {
                        item.TimeOffStatus = 'Not Submitted';
                        item.TimeOffStatusColor = 'badge-light-warning'; 
                    }
                });
                state.timeoffrequestList = timeOffRequestList;
                state.isShowGrid = timeOffRequestList.length > 0 ? true : false;
                state.pageNo = action.payload.currentPage;
                state.startRec = action.payload.start;
                state.totalItems = action.payload.recordsTotal;
                state.search = action.payload.searchText;
                state.recordsFiltered = action.payload.recordsFiltered;             
                state.isLoading = false;
            })
            .addCase(getTimeOffRequestList.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(getTimeOffRequestStatusList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getTimeOffRequestStatusList.fulfilled, (state, action) => {
                state.timeoffrequeststatusList = action.payload.hasOwnProperty("Id") ? [] : action.payload;
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(getTimeOffRequestStatusList.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(addAccountEmployeeTimeOffRequest.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(addAccountEmployeeTimeOffRequest.fulfilled, (state, action) => {
                state.status = 'idle';
                const { res, reduxObject } = action.payload as any;
                if (res.constructor == Array) {
                    reduxObject.AccountEmployeeTimeOffRequestId = res[0].AccountEmployeeTimeOffRequestId;
                    reduxObject.Approved = res[0].Approved;
                    reduxObject.Rejected = res[0].Rejected;
                    reduxObject.TimeOffStatus = setTimesheetStatus(res[0].Approved, res[0].Rejected, (res[0].Approved == false && res[0].Rejected == false ? true : false)).text;
                    reduxObject.TimeOffStatusColor = setTimesheetStatus(res[0].Approved, res[0].Rejected, res[0].Approved == false && (res[0].Rejected == false ? true : false)).class;
                    state.timeoffrequestList.unshift(action.payload.reduxObject);
                }
                state.isLoading = false;
                state.isReloadStatus = true;
            })
            .addCase(addAccountEmployeeTimeOffRequest.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(updateAccountEmployeeTimeOffRequest.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateAccountEmployeeTimeOffRequest.fulfilled, (state, action) => {
                state.status = 'idle';
                const { res, reduxObject, id } = action.payload as any;
                if (id != '') {
                    state.timeoffrequestList.map((item: any) => {
                        if (item.AccountEmployeeTimeOffRequestId == id) {
                            item.StartDate = reduxObject.StartDate;
                            item.EndDate = reduxObject.EndDate;
                            item.HoursOff = reduxObject.HoursOff;
                            item.DayOff = reduxObject.DayOff;
                            item.Description = reduxObject.Description;
                            item.AccountTimeOffTypeId = reduxObject.AccountTimeOffTypeId;
                            item.AccountProjectId = reduxObject.AccountProjectId;
                            if (reduxObject.IsSaveDraft === false || reduxObject.IsSaveDraft === 'false') {
                                item.TimeOffStatus = 'Submitted';
                                item.TimeOffStatusColor = 'badge-light-primary'; 
                            } else {
                                item.TimeOffStatus = 'Not Submitted'; 
                                item.TimeOffStatusColor = 'badge-light-warning';
                            }
                        }
                    })
                }
                state.isLoading = false;
                state.isReloadStatus = true;

            })
            .addCase(updateAccountEmployeeTimeOffRequest.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(bulkSubmitAccountEmployeeTimeOffRequests.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(bulkSubmitAccountEmployeeTimeOffRequests.fulfilled, (state, action) => {
                state.status = 'idle';
                const { res, ids } = action.payload as any;

                if (ids && ids.length > 0) {
                    state.timeoffrequestList.map((item: any) => {
                        if (ids.includes(item.AccountEmployeeTimeOffRequestId)) {
                            item.TimeOffStatus = 'Submitted';
                            item.TimeOffStatusColor = 'badge-light-primary';
                        }
                    });
                }

                state.isLoading = false;
                state.isReloadStatus = !state.isReloadStatus;
            })
            .addCase(bulkSubmitAccountEmployeeTimeOffRequests.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })



            .addCase(deleteAccountEmployeeTimeOffRequest.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteAccountEmployeeTimeOffRequest.fulfilled, (state, action) => {
                state.status = 'idle';
                state.timeoffrequestList = state.timeoffrequestList.filter(x => x.AccountEmployeeTimeOffRequestId != action.payload.Id);
                state.isLoading = false;
            })
            .addCase(deleteAccountEmployeeTimeOffRequest.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
    }
})

export const {
    resetSelectedFiltersInState,
    updatePagination,
    updateSearchPagination,
    updateIsLoading,
    updateAccountEmployeeTimeOffRequestId,
    updatePreferences,
    updateSorting,
    setDateRangeValue,
    updateAccountTimeOffTypeId,
    updateAccountTimeOffStatus,
    setPageSize,
    setSelectedTimeOffStatus
} = timeoffrequestSlice.actions
export const TimeOffRequestState = (state: RootState) => state.timeoffrequest
export default timeoffrequestSlice.reducer